export default "__VITE_ASSET__CMKCjhQZ__"